import { render, staticRenderFns } from "./fahuolist_expand.vue?vue&type=template&id=3f604ac8&scoped=true"
import script from "./fahuolist_expand.vue?vue&type=script&lang=js"
export * from "./fahuolist_expand.vue?vue&type=script&lang=js"
import style0 from "./fahuolist_expand.vue?vue&type=style&index=0&id=3f604ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f604ac8",
  null
  
)

export default component.exports